import { breakpoints, theme } from "@shapeable/theme";
import { WARM_GREY } from "@shapeable/ui";
import { css } from "styled-components";

export const YELLOW = '#FFCA04';
export const YELLOW_DARK = '#FCB10F';
export const YELLOW_ORANGE = '#F79616';

export const SYNC_BLUE = '#00A9B4';
export const SYNC_BLUE_LIGHT = '#04c2cf';

export const themeOverrides = {
  light: {
    color: {

      darkBackground: '#202124',
      lightBackground: '#F8F8F8',
  
      midBrand: YELLOW_DARK,
      primary: YELLOW_DARK,
  
  
      buttonHover: YELLOW_DARK,
      linkHover: SYNC_BLUE_LIGHT,
      link: SYNC_BLUE,
      // linkInvertedHover: YELLOW,
      // linkActive: YELLOW,
  
      // menuItemLinkHover: YELLOW_DARK, 
      // menuItemLinkActive: YELLOW_DARK, 
      // invertedMenuItemLinkHover: YELLOW_DARK, 
  
    },
  },
  font: {
    family: {
      serif: "Cormorant, georgia, serif",
      sans: 'Inter, sans-serif',
      heading: 'Inter, sans-serif',
      copy: 'Inter, sans-serif',
    }
  },
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`

    .page-home .shp--page-layout-standard__banner-titles div div {
      flex-direction: column;
      gap: 0.25em;

      h1 {
        align-self: flex-start;
      }
    }

    .shp--slice-intro {
      font-size: 1.75em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--site-menu-bar__title {
      color: ${theme.COLOR('light')}
    }

    .shp--slice-key-message {
      text-align: left;

      .shp--content {
        line-height: 1.10em;
        font-family: ${theme.FONT('serif')};
      }
      
      .shp--slice-key-message__links {
        align-items: flex-start;
      }
    }

    .shp--slice-layout-content-with-image {
      .shp--content-node {
        color: ${theme.COLOR('inherit')};
      }
      li::before {
        color: ${theme.COLOR('inherit')};
      }
    }

    #customers .shp--button {
      color: ${theme.COLOR('light')};
      ${theme.FILL('light')};
      border: 2px dotted ${theme.COLOR('light')};
      &:hover {
        color: ${theme.COLOR('#FCB10F')};
        ${theme.FILL('#FCB10F')};
        border: 2px dotted ${theme.COLOR('#FCB10F')};
      }
    }

    .shp--slice-section-color-block {
      h1 {
        margin: 0;
      }
      strong {
        font-weight: 600;
      }
    }

    .shp--slice-layout-knowledge-hub {
      .shp--entity-grid__filter {
        padding-bottom: ${theme.UNIT(2)};
      }
    }
    

  `,
  tablet: css`
    .shp--slice-intro {
      font-size: 2em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--slice-layout-knowledge-hub {
      .shp--entity-grid__filter {
        padding-bottom: ${theme.UNIT(5)};
      }
    }

  `,
  desktop: css`
    .shp--slice-section-color-block {
      min-height: 600px;
      h1 {
        font-size: 2em;
        margin: 0;
      }
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      gap: 1em;
    }

    
    
  `,
});